import TagManager from '../../../../classes/TagManager';
import ArrowRight from '../../../atoms/icons/ArrowRight';
import { TriangleDown, CarretArrowRight } from '../../../atoms/icons';
import styles from './AccountNavigation.module.scss';
import navItems from './navItemsData';
import app from '@frontastic/catwalk/src/js/app/app';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { useMedia } from 'react-use';
import { useWishlistContext } from '../../../../provider/wishlist/WishlistContext';
import { theme } from './_vars';
import proxyFetch from '@frontastic/bridge/js/fetch';
import { usePageLoading } from '@frontastic/catwalk/js/helper/hooks/usePageLoading';
import { useNoticesContext } from '@srcDS/provider/notices/NoticesContext';

const AccountNavigation = ({ userName, activeMenu = null, closeAction, omneoAccountLink, accountId, omneo }) => {
  const pathName = usePathname();
  const { resetNextWishlistAction } = useWishlistContext();
  const isDesktop = useMedia('(min-width: 767px)', true);
  const [link, setLink] = useState(null);
  const [isClicked, setClicked] = useState(false);
  const { dispatchPageLoadingStart, dispatchPageLoadingDone } = usePageLoading();
  const { setNotices } = useNoticesContext();

  useEffect(() => {
    if (!link && accountId && omneo?.tenant && isClicked) {
      proxyFetch(`/custom_api/commercetools/customer/getOmneoToken`, { method: 'POST' })
        .then((response) => {
          if (!response.ok) {
            throw response;
          }
          return response.json();
        })
        .then((body) => {
          const token = body.data.token;

          const linkOmneo = `https://my.${theme.toLowerCase()}.com.au/login?token=${btoa(token)}&mode=null&enableAppointment=null&externalRedirect=null`;

          setLink(linkOmneo);
          setClicked(false);

          window.open(linkOmneo, '_blank');
        });
    }
  }, [accountId, link]);

  const handleClick = (id) => {
    const currentNav = navItems.find((x) => x.id === id);
    if (id === 'SUBS_PREFER') {
      if (accountId) return accountId && link ? window.open(link, '_blank') : window.open(omneoAccountLink, '_blank');

      setClicked(true);

      if (!link) app.getLoader('context').refresh();
      return;
    }

    if (id === 'LOGOUT') {
      dispatchPageLoadingStart();
      app
        .getLoader('context')
        .logout()
        .catch((error) => {
          dispatchPageLoadingDone();
          throw error;
        })
        .then(() => {
          resetNextWishlistAction();
          TagManager.logoutEvent();
          sessionStorage.removeItem('newsLetterEmail');
          app.getRouter().history.replace('/');
          setNotices({ type: 'success', code: 'account.message.logout' });
        });
      return;
    }

    closeAction && closeAction();
    return app.getRouter().push(currentNav.route);
  };

  return (
    <div className={styles.container}>
      <h4 className={styles.userName}>Hello, {userName}</h4>
      <div className={styles.navBlock}>
        {navItems.map((nav) => {
          return (
            <div
              key={nav.id}
              onClick={() => handleClick(nav.id)}
              className={clsx(styles.navItem, {
                [` ${styles.navItemActive}`]: nav.id === activeMenu || nav.pathname === pathName,
              })}
            >
              <div
                className={clsx(styles.navItemText, {
                  [styles.withIcon]: nav.id === 'SUBS_PREFER',
                })}
              >
                <span className={styles.navName}>{nav.name}</span>
                <span className={styles.navDesc}>{nav.desc}</span>
              </div>
              <span className={styles.navItemIcon}>
                {nav.id === 'SUBS_PREFER' ? (
                  <ArrowRight className={styles.iconArrow} />
                ) : !isDesktop ? (
                  theme === 'Jag' ? (
                    <TriangleDown className={styles.iconTriangleArrow} />
                  ) : (
                    <CarretArrowRight className={styles.iconCaretArrow} />
                  )
                ) : (
                  ''
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

AccountNavigation.propTypes = {
  userName: PropTypes.string,
  activeMenu: PropTypes.string,
};

export default AccountNavigation;
